import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Reveal } from "./Reveal";
import { scrollTo } from "./Nav";

const IMAGES = [
  "https://images.unsplash.com/photo-1600210492493-0946911123ea?fm=jpg&q=80&w=1600&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1615529182904-14819c35db37?fm=jpg&q=80&w=1600&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1711059985570-4c32ed12a12c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjA0MTJ8MHwxfHNlYXJjaHwxfHxib3V0aXF1ZSUyMGhvdGVsJTIwYmVkcm9vbXxlbnwwfHx8fDE3ODY4MzM0Mjh8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjByZWFsJTIwZXN0YXRlJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4NjgzMzQyOHww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1594479125841-ff7800c6afcc?fm=jpg&q=80&w=1600&auto=format&fit=crop",
];

export const Services = () => {
  const { t } = useTranslation();
  const rows = t("services.rows", { returnObjects: true });
  const [active, setActive] = useState(0);

  return (
    <section id="servizi" className="relative bg-[#0D0F12] px-6 py-20 lg:px-12 lg:py-28" data-testid="services-section">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <p className="font-code text-[11px] uppercase tracking-[0.35em] text-[#D6705A]">{t("services.overline")}</p>
          <h2 className="mt-4 max-w-2xl font-display text-4xl font-light leading-tight text-[#F9F8F6] sm:text-5xl lg:text-6xl">
            {t("services.h2pre")} <em className="italic text-[#D6705A]">{t("services.h2em")}</em> {t("services.h2post")}
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            {rows.map((s, i) => (
              <Reveal key={s.title} delay={i * 0.08}>
                <button
                  onMouseEnter={() => setActive(i)}
                  onClick={() => scrollTo("#prenota")}
                  className="group flex w-full items-start justify-between gap-6 border-t border-white/10 py-6 text-left transition-colors duration-300 last:border-b hover:border-[#D6705A]/40"
                  data-testid={`service-row-0${i + 1}`}
                >
                  <div className="flex items-baseline gap-6">
                    <span className="font-code text-xs text-[#666]">0{i + 1}</span>
                    <div>
                      <h3 className="font-display text-2xl font-light text-[#F9F8F6] transition-colors duration-300 group-hover:text-[#D6705A] md:text-3xl">
                        {s.title}
                      </h3>
                      <p className="mt-2 max-w-md text-sm leading-relaxed text-[#A0A0A0]">{s.desc}</p>
                    </div>
                  </div>
                  <ArrowUpRight className="mt-2 h-5 w-5 shrink-0 text-[#666] transition-[color,transform] duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-[#D6705A]" />
                </button>
              </Reveal>
            ))}
          </div>

          <div className="relative hidden lg:col-span-5 lg:block">
            <div className="sticky top-28 aspect-[4/5] overflow-hidden rounded-2xl">
              <AnimatePresence mode="wait">
                <motion.img
                  key={`${active}-${rows[active].title}`}
                  src={IMAGES[active]}
                  alt={`${rows[active].title} — ${t("portfolio.imgAltSuffix")}`}
                  className="h-full w-full object-cover"
                  loading="lazy"
                  decoding="async"
                  initial={{ opacity: 0, scale: 1.06 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
                  data-testid="services-preview-image"
                />
              </AnimatePresence>
              <div className="absolute inset-0 bg-black/20" />
              <div className="absolute bottom-4 left-4 font-code text-[10px] uppercase tracking-[0.3em] text-[#F9F8F6]/80">
                0{active + 1} — {rows[active].title}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
